export default __webpack_public_path__ + "static/media/ecodat.76aa4243.svg";